import rAxios from "utils/rAxios";
import { LOG_TYPE } from "./logs.model";

export const sendLog = (type: LOG_TYPE, details?: string) =>
	rAxios.post("/user/clientlog", {
		log_type: type,
		details,
	});
